import _ from 'lodash';
import qs from 'query-string';

export default function getUTMParams(location) {
    return qs.parse(_.get(location, 'search', ''));
}



// WEBPACK FOOTER //
// ./src/scenes/getUTMParams.js